import React, { useRef, useState } from "react";
import MainImage from "../assets/Blackwomen/BWI26.jpg";
import Footer from "../components/Footer";
import NavLite from "../components/NavLite";
import { Helmet } from "react-helmet";
import emailjs from "emailjs-com";

const SERVICE_ID = "service_r8n2pam";
const TEMPLATE_ID = "template_es2uhv6";
const PUBLIC_KEY = "z6B6FSYvn-nOClTyA";

function Contact() {
  const formRef = useRef();
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(() => {
        setShowModal(true);
        formRef.current.reset();
      })
      .catch((error) => {
        alert(`There was an error submitting your form: ${error.text}`);
      });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <section>
 <Helmet>
  <title>Contact Woaom Web Design | Book Your Website & Branding Consult</title>
  <meta
    name="description"
    content="Connect with Woaom Web Design to start your project. Book a discovery call for custom web design, branding, or app development. Serving women entrepreneurs in Dallas, Houston, Austin, Atlanta, New York City, and more."
  />
  <meta
    name="keywords"
    content="Contact Woaom Web Design, Dallas web design contact, Houston TX design studio contact, Austin TX web design consultation, Atlanta GA website design inquiry, New York City women-led web design contact, Washington DC web design consult, Philadelphia PA custom website request, Memphis TN women entrepreneur web design support, Baton Rouge LA design studio contact, Shreveport LA website consultation, New Orleans design agency contact, Macon GA web design contact form, Augusta GA website designer contact, Baltimore women-owned web design studio, book a call with Woaom Web Design, schedule a discovery call web design, start your project web design studio, request a quote for web design, women-led web design agency consultation, branding and website support contact, connect with a female web studio, entrepreneur website help contact, founder-focused design studio contact form, start your glow up consultation, professional web design support Dallas TX, custom website quote Houston TX, contact form for Woaom Web Design"
  />
</Helmet>


      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <NavLite />
        <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
          <div className="flex items-center justify-center">
            <h1 className=" text-white italic text-3xl max-w-56 font-bold backdrop-blur-sm">Contact US</h1>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <div className="grid items-center gap-8 sm:gap-20 md:grid-cols-2">
          <div className="max-w-3xl">
            {/* Left Side Text */}
            <h2 className="mb-2 text-3xl font-bold md:text-5xl italic uppercase">
              LET’S <span className="bg-[#CFF098] text-black italic">DO THIS</span>
            </h2>
            <p className="my-4 max-w-lg pb-4 text-sm text-gray-200">
              For questions or just to say hi, feel free to reach out here or email us directly at ruth@woaomwebdesign.com.
              <br /><br />
              Or{" "}
              <a href="https://cal.com/woaomwebdesign/15min" className="underline">
                schedule an intro call!
              </a>
            </p>
            <h5 className="text-xl mb-5 bg-[#CFF098] text-black italic max-w-[280px]">
              Contact Woaom Web Design
            </h5>
            <ul className="space-y-2 text-white">
              <li><strong>Email:</strong> <a href="mailto:ruth@woaomwebdesign.com">ruth@woaomwebdesign.com</a></li>
              <li><strong>Phone:</strong> <a href="tel:+15033890185">(737) 304-5965</a></li>
              <li><strong>Address:</strong> 1422 Collier St, Austin, TX 78704</li>
            </ul>
          </div>

          {/* Right Side Form */}
          <div className="mx-auto max-w-xl bg-[#F7F3F2] p-8 text-center">
            <h3 className="text-2xl font-bold md:text-3xl text-black">
              Your Brand.{" "}
              <span className="bg-[#CFF098] text-black italic"> Your Platform.</span>{" "}
              Dominate Search.
            </h3>
            <p className="mx-auto mb-6 mt-4 max-w-lg text-sm text-gray-600">
              We build custom-branded platforms engineered to rank #1 on Google.
            </p>

            <form
              ref={formRef}
              className="mx-auto mb-4 max-w-sm text-left text-black"
              name="contact-form"
              onSubmit={handleSubmit}
            >
              <div>
                <label className="mb-1 font-medium bg-[#CFF098] text-black italic">
                  Your Name
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="mb-4 block w-full rounded-md border border-black px-3 py-2 text-sm"
                />
              </div>

              <div className="mb-2">
                <label className="mb-1 font-medium bg-[#CFF098] text-black italic">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="mb-4 block w-full rounded-md border border-black px-3 py-2 text-sm"
                />
              </div>

              <div className="mb-4">
                <label className="mb-1 font-medium bg-[#CFF098] text-black italic">
                  Services
                </label>
                <select
                  name="service"
                  required
                  className="mb-4 block w-full rounded-md border border-black px-3 py-2 text-sm"
                >
                  <option value="">Select a Service</option>
                   <option value="Website Glow-Up">Hair Braiding Starter Braider Websites</option>
                   <option value="Website Glow-Up">Hair Braiding Growth & Marketing Bundle</option>
                   <option value="Website Glow-Up">Hair Braiding VIP Website + Maintenance Plan</option>
                  <option value="Website Glow-Up">Website Glow-Up — Custom 5-page site</option>
                  <option value="Website Glow-Up Pro">Website Glow-Up Pro — 7–10 pages + CMS</option>
                  <option value="Launch Glow-Up (MVP App)">Launch Glow-Up — 5-screen MVP</option>
                  <option value="Business Glow-Up">Business Glow-Up — App + CMS + APIs</option>
                  <option value="CEO Glow-Up">CEO Glow-Up — Enterprise App</option>
                  <option value="Other">Other Custom Projects</option>
                </select>
              </div>

              <div className="mb-6">
                <label className="mb-1 font-medium bg-[#CFF098] text-black italic">
                  Project Brief
                </label>
                <textarea
                  name="brief"
                  required
                  className="block min-h-32 w-full rounded-md border border-black p-3 text-sm"
                />
              </div>

              <input
                type="submit"
                value="Start Project Now"
                className="inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border border-black shadow-sm cursor-pointer"
              />
            </form>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 flex justify-center items-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg text-center max-w-lg">
            <h2 className="text-2xl font-bold bg-[#CFF098] text-black italic">Thank You!</h2>
            <p className="mt-4 text-lg text-gray-700">
              Your service request has been submitted successfully. We'll be in touch to start your project!
            </p>
            <button
              onClick={handleCloseModal}
              className="mt-6 bg-[#CFF098] text-black px-6 py-2 rounded-full"
            >
              Close
            </button>
          </div>
        </div>
      )}
      <Footer />
    </section>
  );
}

export default Contact;
